import { Box } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import MedicationFilterForm from "../../MedicationFilterForm";

export default function MedicationFilterModal({ close }) {
  return (
    <Box
      sx={{
        width: '510px',
        padding: '16px',
        borderRadius: '16px',
        backgroundColor: 'background.default',
        overflowY: 'none',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        py: '60px'
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '10px',
          right: '20px',
          height: '40px',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center'
        }}
      >
        <CloseIcon
          sx={{
            width: '32px',
            height: '32px',
            color: 'primary.black',
            cursor: 'pointer'
          }}
          onClick={close}
        />
      </Box>
      <MedicationFilterForm  onClose={close} />
    </Box>
  )
}